/**
 * Standard API success wire shape: `{ success, data, message }`.
 * After axios unwrap, callers receive `data` only.
 */

function isPlainObject(value: unknown): value is Record<string, unknown> {
  return value !== null && typeof value === 'object' && !Array.isArray(value) && !(value instanceof Blob)
}

export function unwrapSuccessPayload(body: unknown): unknown {
  if (!isPlainObject(body)) return body
  if (typeof body.success !== 'boolean' || !('data' in body)) return body
  const unwrapped = body.data
  const message = typeof body.message === 'string' ? body.message : undefined

  if (!message || !isPlainObject(unwrapped) || 'message' in unwrapped) {
    return unwrapped
  }

  return { ...unwrapped, message }
}
